<template>
    <div>
   
        <div v-if="saved">
            <form-saved-success :dis="false" @RepeatAppeal="onRepeatAppeal"
                :idParams="savedId"></form-saved-success>
        </div>
        <div v-if="!saved" class="responsive-box ">


            <FormViewRun2 ref="fvr" @saveClick="saveFunc" :edit="false" :taslakVisible="true" :formId="$route.params.id">

            </FormViewRun2>
        </div>


    </div>



</template>
<script>

import FormViewRun2 from '../../components/FormViewRun2.vue';
import FormSavedSuccess from '../FormSavedSuccess.vue';

export default {
    components: {
        FormViewRun2,
        FormSavedSuccess
    },

    name: 'OurFormViewRun',
    data: () => ({

        saved: false,
savedId:null,

    }),
    methods: {
        onRepeatAppeal() {
            this.saved = false;
        },
        saveFunc(returnApiValue) {
            // .then((result) => {

            //        router.push({ name: 'FormSavedSuccess', params: { id: this.$route.params.id } })

            // }).catch((err) => {
            //     console.log("Error", err.response.data);
            //     this.$toast.warning(err.response.data)
            // });
            if (returnApiValue.status == 200) {
                this.$refs.fvr.reset();
                this.saved = true;
                    this.savedId=returnApiValue.data.id;

                //router.push({ name: 'FormSavedSuccess', params: { id: this.$route.params.id } })
            } else {
             
               this.$toast.warning("Hata Kodu:INF-61 Beklenmeyen bir sorunla karşılaşıldı.")
            }
           // console.log('Çocuk componentten gelen:', returnApiValue);
        }
    }
}
</script>
<style scoped>
.responsive-box {
    width: 100%;
    max-width: 800px;
    margin: auto;
}
</style>